/**
 * Fournisseur de session NextAuth pour l'app
 *
 * Rôle : Enveloppe l'application pour que useSession() et getServerSession() fonctionnent.
 * Configure le rafraîchissement de session (refetchInterval) sans refetch au focus.
 * Technologies : next-auth (SessionProvider), React
 */
"use client";

import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";
import { ReactNode } from "react";

interface SessionProviderProps {
  children: ReactNode;
}

export default function SessionProvider({ children }: SessionProviderProps) {
  // Ne pas passer baseUrl : NextAuth utilise l’origine courante, ce qui évite
  // CLIENT_FETCH_ERROR (réponse HTML au lieu de JSON) quand l’URL ne correspond pas.
  return (
    <NextAuthSessionProvider
      refetchInterval={5 * 60}
      refetchOnWindowFocus={false}
    >
      {children}
    </NextAuthSessionProvider>
  );
}
